export const scroll = (element) => {
    try {
        const section = document.querySelector(element);
        section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    } catch (e) {
        console.log(`Error scroll to element ${element} | ${element}`)
    }
}
